/* eslint-disable no-param-reassign */
import { getSearchObj } from '@tencent/magic-ui-util';
import { YYB_APP_IDS } from '../../../src/constant/index';

const location = window.location.href === 'about:blank' ? window.parent.location : window.location;
const params = getSearchObj(location.search);
export default {
  name: 'style',
  items: [{
    name: 'backgroundImage',
    text: '背景图',
    type: 'upload',
    drag: true,
    tooltip: YYB_APP_IDS.indexOf(params.appId?.toString()) > -1 ? '请确保上传的组件背景图符合规范（组件大小将锁定为图片1/2比例）！' : '',
    onChange: async (vm, v = '', { model, formValue }) => {
      v = v.trim();
      if (v) {
        const imgEl = await new Promise((resolve) => {
          const img = new Image();
          img.onload = function () {
            resolve(this);
          };
          img.src = v;
        });

        const type = formValue.type.replace(/-(\w)/g, (all, letter) => letter.toUpperCase());

        if (type === 'rulePop') {
          model.backgroundSize = '100% auto';
        } else {
          if (['pop', 'sharePop'].includes(type)) {
            model.width = window.document.querySelector('.magic-ui-page').clientWidth * 0.8;
            model.height = model.width * imgEl.height / imgEl.width;
          } else {
            if (YYB_APP_IDS.indexOf(params.appId?.toString()) > -1) {
              formValue.style.width = Math.floor(imgEl.width / 2) || '100%';
              formValue.style.height = Math.floor(imgEl.height / 2) || '100%';
              if (!formValue.devconfig) {
                vm.$set(formValue, 'devconfig', {});
              }
              vm.$set(formValue.devconfig, 'resizable', false);
            } else {
              const clientWidth = document.getElementById(formValue.id).clientWidth || model.width;
              formValue.style.height = clientWidth * imgEl.height / imgEl.width || '100%';
            }
          }
          if (model.customBackgroundSize) {
            model.backgroundSize = model.customBackgroundSize;
          } else {
            model.backgroundSize = '100% 100%';
          }
        }
        model.backgroundRepeat = 'no-repeat';
      } else {
        if (formValue.devconfig && formValue.devconfig.resizable === false) {
          formValue.devconfig.resizable = true;
        }

        // 如果没有内容，要判断是否有背景图切割标志，有要置为空
        model.backgroundCrop && vm.$delete(model, 'backgroundCrop');
        model.backgroundParts && vm.$delete(model, 'backgroundParts');
      }
    },
  }, {
    type: 'row',
    span: 12,
    items: [{
      name: 'backgroundColor',
      text: '背景颜色',
      type: 'colorPicker',
    }, {
      name: 'backgroundRepeat',
      text: '背景图重复',
      type: 'hidden',
      defaultValue: 'no-repeat',
      options: [
        { text: 'repeat', value: 'repeat' },
        { text: 'repeat-x', value: 'repeat-x' },
        { text: 'repeat-y', value: 'repeat-y' },
        { text: 'no-repeat', value: 'no-repeat' },
        { text: 'inherit', value: 'inherit' },
      ],
    }],
  }, {
    name: 'backgroundSize',
    text: '背景图大小',
    type: 'hidden',
    defaultValue: '100% 100%',
  }],
};
